import { ref } from 'vue';
import dataMasterRepository from '@/repositories/general/dataMasterRepository';

export function useGenDestinationType() {
  const listDestinationType = ref([]);

  const getData = async () => {
    try {
      const data = await dataMasterRepository.getDestinationType();
      if (data.data.status === 200) {
        listDestinationType.value = data.data.data.destination_type.list;
      }
    } catch (error) {
      console.log(error);
    }
  };

  getData();

  return { listDestinationType };
}
